import TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './pdfEditor.html?raw';

import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import pdfViewer from '../../../WidgetCollection/fileViewer/pdfViewer/pdfViewer';

import * as pdfTypes from "./../../fileViewer/pdfViewer/pdfTypes";

class pdfEditor extends compose(TabEnabledMixin) {
    templateString: any = template;

    public overwrite_config: (config:pdfTypes.PdfViewerConfig) => pdfTypes.PdfViewerConfig;
    private fileKey:string;
    private pdfContainer:HTMLDivElement;
    private isSaved = true;
    private pdfIsLoaded = false;
    private pdfViewer:MdsLax<InstanceType<typeof pdfViewer>>;
    private dlg:MdsLax<InstanceType<typeof GenericDialog>>;
    private dlg_header:string;
    private flagUseOwnDlg: boolean = false;
    private actualFileID:string;
    private timeoutFix:any;
    private pdfSaveIconButton: HTMLButtonElement = null;
    postCreate(): void {
        this.dlg_header = this.translate("PdfEditor_header");
        this.on("dirty", lang.hitch(this, this._onDirty));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    destroy(){
        clearTimeout(this.timeoutFix);
    }

    private _onDirty(dirty:boolean){
        if (this.flagUseOwnDlg){
            //this.dlg.disableAllButtons(dirty);
            if (dirty){
                this.dlg._setHeaderAttr(this.dlg_header + " (*)");
            }else{
                this.dlg._setHeaderAttr(this.dlg_header);
            }
        }
        if (this.pdfViewer.config.ToolbarConfig.SaveButton == true){
            if (dirty){
                this.pdfSaveIconButton.classList.remove("pdfEditorSaveIconColorSaved");
                this.pdfSaveIconButton.classList.add("pdfEditorSaveIconColorUnsaved");
            }else{
                this.pdfSaveIconButton.classList.add("pdfEditorSaveIconColorSaved");
                this.pdfSaveIconButton.classList.remove("pdfEditorSaveIconColorUnsaved");
            }
        }
    }
    private setPdfViewerConfig(){
        //ziel der config ist es, alles zu enablen was auch wieder im pdf file abgespeichert wird...
        this.pdfViewer.config.ToolbarConfig = {
            OpenOption: false,//open file (browser upload) macht keinen sinn, oder?
            PageNavigationTool: true,
            MagnificationTool: true,
            PanTool: true,
            SelectionTool: true,
            SearchOption: true,
            PrintOption: false,
            DownloadOption: false,
            UndoRedoTool: true,
            AnnotationEditTool: true, //werden anscheinend nicht seperat vom dokument abgespeichert?!?!
            FormDesignerEditTool: true,
            CommentTool: true,
            SubmitForm: false,
            SaveButton: true,
            ToggleFullScreen: true,
            YouSignSignature: false,
        };
        this.pdfViewer.config.stickyNotes.enableStickyNotes = true; //werden anscheinend nicht seperat vom dokument abgespeichert?!?!
        this.pdfViewer.config.cancelDownloads = false;
        this.pdfViewer.config.pageOrganizerSettings = {
            enablePageOrganizer: true,
            canCopy: true,
            canDelete: true,
            canImport: true,
            canInsert: true,
            canRearrange: true,
            canRotate: true
        };

        //da wir saveAs nicht so richtig disablen koennen, mappen wir einfach saveAs auf save
        //danke dafür syncfusion
        this.pdfViewer.config.experimental["disable_pageOrganizer_saveAs_click"] = true; //weil wir eigentlich nicht wollen, dass die datei runtergeladen wird...
        this.pdfViewer.config.experimental["disable_annotation_import_export_menu_click"] = true; //import exports soll vom editor gehandlet werden, nicht vom user

        if (typeof this.overwrite_config != 'undefined'){
            if (typeof this.overwrite_config == 'function'){
                this.pdfViewer.config = this.overwrite_config(this.pdfViewer.config);
            }
        }
    }

    public show(key: FileFinder.DescriptorRequestData, showAsDlg:boolean){
        this.pdfIsLoaded = false;
        this.fileKey = key.key;

        if (showAsDlg){
            this.dlg = new GenericDialog();
            this.dlg.destroyOnClose = true;
            this.dlg.closeOnEnter = false;
            this.dlg.closeOnEscape = false;
            this.dlg.setSize('larger');
            this.dlg.show(this, this.dlg_header, null, null, 'close');
            this.dlg._setTopCloseBtnAttr(false);
            this.flagUseOwnDlg = showAsDlg;
        }

        this.loadFile();

    }

    private loadFile(){
        this.emit("downloadFileStart");
        this.RequestManager.callfunction("Webtool_API_FileTransfer__DownloadDescriptorByKey",
            { key: this.fileKey },
            lang.hitch(this, (res:any)=>{
                this.emit("downloadFileFinished");
                //weil der coole syncfusion pdfviewer ansonsten evtl. nicht richtig die layout breite rendered...
                this.timeoutFix = setTimeout(lang.hitch(this, this._onResponse_DownloadDescriptorByKey, res), 300);
            }),
            lang.hitch(this, (err) => {
                console.error(err);
                this.showToast(this.translate("General_Error") + ":" + err.Message, "far fa-dizzy");
            }),
            false
        );
    }

    /**
     * Laded ein base64 Pdf Dokument als alternative zu show().
     *
     * @param base64String base64 string vom Pdf Dokument
     * @param vt_files_id  ID vom vt_file Objekt (zum Speichern)
     */
    public async loadBase64(base64String:string, vt_files_id:string){
        let res = {
            base64Content: base64String,
            fileEntity:{
                ID: vt_files_id
            },
            downloadKey:vt_files_id,
        };
        return await this._onResponse_DownloadDescriptorByKey(res as any as FileFinder.FileDescriptorWithBase64);
    }
    private async _onResponse_DownloadDescriptorByKey(res: FileFinder.FileDescriptorWithBase64){
        this.emit("pdfLoadStart");
        let base64Data = res.base64Content;

        if (res.hasOwnProperty("fileEntity")){
            this.actualFileID = res.fileEntity.ID;
        }else{
            this.actualFileID = res.downloadKey; //fallback, wird zwar nicht gut gehen aber...
        }

        this.pdfViewer = new pdfViewer();
        this.setPdfViewerConfig();

        this.pdfViewer.placeAt(this.pdfContainer);
        this.pdfContainer.classList.remove("w3-hide");
        this.StandbyStart();
        this.pdfViewer.on("allEventsReady", lang.hitch(this, ()=>{
            this.StandbyStop();
        }));

        this.pdfViewer.on("pageRenderCompleteFirstLoad", lang.hitch(this, this._onFirstLoad_pdf));
        this.pdfViewer.on("saveButton", lang.hitch(this, this._onSave_pdf));
        this.pdfViewer.on("pageOrganizer_saveAsClick", lang.hitch(this, this._onClick_PageOrganizer_SaveAs));

        this.pdfViewer.loadPdfByBase64(base64Data);
        this.pdfViewer.on("annotationsChanged", lang.hitch(this, this._onChanged_pdf));
        this.pdfViewer.on("formFieldChanged", lang.hitch(this, this._onChanged_pdf));
        this.pdfViewer.on("yousignFieldAdded", lang.hitch(this, (field:any)=>{
            this.emit("yousignFieldAdded", field);
        }));
        this.pdfViewer.on("pageRenderCompleteFirstLoad", lang.hitch(this, (obj:any)=>{
            this.emit("pageRenderCompleteFirstLoad", obj);
        }));
        this.pdfViewer.on("formFieldMove", lang.hitch(this, (args:any)=>{
            this.emit("formFieldMove", args);
        }));
        this.pdfViewer.on("formFieldResize", lang.hitch(this, (args:any)=>{
            this.emit("formFieldResize", args);
        }));
        this.pdfViewer.on("formFieldRemove", lang.hitch(this, (args:any)=>{
            this.emit("formFieldRemove", args);
        }));
        this.pdfViewer.on("yousignMobileModeDetected", lang.hitch(this, (args:any)=>{
            this.emit("yousignMobileModeDetected", args);
        }));
        this.pdfViewer.on("pageRenderComplete", lang.hitch(this,(args:any)=>{
            this.emit("pageRenderComplete", args);
        }));
    }

    private _onFirstLoad_pdf(){
        this.pdfIsLoaded = true;
        this.pdfContainer.classList.remove("w3-hide");
        this.pdfSaveIconButton = this.domNode.querySelector(".pdfEditorSaveIconButton");
        this.emit("dirty",false);
        this.emit("pdfLoadFinished");
    }
    private _onSave_pdf(){
        this.emit("fileOverwriteStart");
        this.StandbyStart();
        this.pdfViewer.download(true, 'Base64String', lang.hitch(this, this._onDownloadToString_Pdf));
    }

    private _onDownloadToString_Pdf(downloadToMemContent: string):void{
        this.RequestManager.callfunction(
            "Webtool_API_FileTransfer__OverwriteFileByID",
            { key: this.actualFileID, base64Content: downloadToMemContent },
            lang.hitch(this, this._onCallback_OverWriteFile),
            lang.hitch(this, (err)=>{
                console.error(err);
                this.showToast(this.translate("General_Error") + ":" + err.Message, "fas fa-bug");
                this.StandbyStop();
            })
        );
    }

    private _onCallback_OverWriteFile(res:any){
        this.emit("dirty",false);
        this.StandbyStop();
        console.info("new version of pdf was saved:", res);
        this.emit("fileOverwriteFinished");
    }
    private _onChanged_pdf(){
        if (this.pdfIsLoaded == false){
            return;
        }
        this.emit("dirty",true);
    }
    private _onClick_PageOrganizer_SaveAs(){
        //da wir den saveAs Button nicht disablen koennen, uberschreiben wir einfach die Funktion mit dem Save-Button click...
        //this.pdfViewer.getSyncFusionPdfViewer().pageOrganizer.onSaveClicked();
        this.showToast(this.translate("General_FunctionNotAvailable"), "fas fa-info");
    }

    public getPdfViewerWidget(){
        return this.pdfViewer;
    }

    public setYousignSignatureState(setSignatureState: boolean){
        return this.pdfViewer.setYousignSignatureState(setSignatureState);
    }

    public yousign_addSigBtn_disabled(isDisabled:boolean){
        return this.pdfViewer.yousign_addSigBtn_disabled(isDisabled);
    }
}

export default mdsWidget(pdfEditor);
